var map = {
	"./appsgoogle_gmail.svg": 25482,
	"./appsgoogle_maps.svg": 92404,
	"./appsgoogle_youtube.svg": 74734,
	"./arrow_down.svg": 99234,
	"./arrow_left.svg": 54351,
	"./arrow_merge.svg": 11010,
	"./arrow_right.svg": 89769,
	"./arrow_up.svg": 22494,
	"./arrowc_rotate_anticlockwise.svg": 55891,
	"./arrowc_rotate_clockwise.svg": 69623,
	"./arrowc_turn_left.svg": 89737,
	"./arrowc_turn_right.svg": 20145,
	"./bulb_light_off.svg": 82346,
	"./bulb_light_on.svg": 22978,
	"./bullet_black.png": 14812,
	"./bullet_blue.png": 21094,
	"./bullet_green.png": 43174,
	"./bullet_orange.png": 22436,
	"./bullet_pink.png": 29222,
	"./bullet_purple.png": 62261,
	"./bullet_red.png": 52808,
	"./chart_bar.svg": 26815,
	"./chart_curve.svg": 70406,
	"./chart_line.svg": 41876,
	"./chart_organisation.svg": 33262,
	"./chart_pie.svg": 43400,
	"./clock-svgrepo-com.svg": 3243,
	"./close.svg": 53674,
	"./conn_connect.png": 72920,
	"./conn_disconnect.png": 27975,
	"./face_crying.svg": 73534,
	"./face_plain.svg": 89760,
	"./face_sad.svg": 10175,
	"./face_smile.svg": 94078,
	"./face_smile_big.svg": 83284,
	"./face_surprise.svg": 45718,
	"./face_wink.svg": 70519,
	"./flag_blue.svg": 26748,
	"./flag_green.svg": 79721,
	"./flag_orange.svg": 14271,
	"./flag_pink.svg": 94655,
	"./flag_purple.svg": 45717,
	"./flag_yellow.svg": 15486,
	"./funy_angel.svg": 7900,
	"./funy_devilish.svg": 89788,
	"./funy_glasses.svg": 2724,
	"./funy_grin.svg": 94286,
	"./funy_kiss.svg": 79383,
	"./funy_monkey.svg": 39054,
	"./hard_cd.svg": 81605,
	"./hard_computer.svg": 56959,
	"./hard_controller.svg": 18642,
	"./hard_drive_cd.svg": 3595,
	"./hard_driver_disk.svg": 70388,
	"./hard_ipod.svg": 66754,
	"./hard_keyboard.svg": 98442,
	"./hard_microphone.svg": 31688,
	"./hard_mouse.svg": 52728,
	"./hard_printer.svg": 29706,
	"./hard_skull.svg": 49676,
	"./hard_webcam.svg": 81787,
	"./links.svg": 88452,
	"./mail_edit.svg": 78315,
	"./mail_envelop.svg": 76221,
	"./mail_list.svg": 58930,
	"./mail_mailbox.svg": 94275,
	"./meetapps_facebook-messenger.svg": 49141,
	"./meetapps_google-meet.svg": 12167,
	"./meetapps_ms-teams.svg": 42828,
	"./meetapps_slack.svg": 85385,
	"./meetapps_whatapp.svg": 9581,
	"./meetapps_zoom.svg": 21479,
	"./money_coins.svg": 78132,
	"./money_dollar.svg": 93529,
	"./money_euro.svg": 64589,
	"./money_money.svg": 75898,
	"./money_pound.svg": 49302,
	"./money_ruby.svg": 8463,
	"./money_yen.svg": 83144,
	"./notes.svg": 5126,
	"./number_1.svg": 48954,
	"./number_2.svg": 74235,
	"./number_3.svg": 18881,
	"./number_4.svg": 94278,
	"./number_5.svg": 61917,
	"./number_6.svg": 17897,
	"./number_7.svg": 4560,
	"./number_8.svg": 67506,
	"./number_9.svg": 76061,
	"./object_bell.svg": 66587,
	"./object_cake.svg": 98560,
	"./object_camera.svg": 67080,
	"./object_clanbomber.svg": 30736,
	"./object_clip.svg": 32458,
	"./object_house.svg": 11066,
	"./object_key.svg": 1842,
	"./object_magnifier.svg": 91292,
	"./object_music.svg": 37188,
	"./object_palette.svg": 53486,
	"./object_pencil.svg": 27211,
	"./object_phone.svg": 31728,
	"./object_rainbow.svg": 20480,
	"./object_star.svg": 568,
	"./object_wizard.svg": 1357,
	"./onoff_add.svg": 80617,
	"./onoff_clock.svg": 74134,
	"./onoff_clock_red.svg": 63455,
	"./onoff_delete.svg": 24148,
	"./onoff_status_offline.png": 88368,
	"./onoff_status_offline.svg": 79181,
	"./onoff_status_online.png": 85341,
	"./onoff_status_online.svg": 29359,
	"./people_female1.svg": 59509,
	"./people_female2.svg": 69090,
	"./people_group.svg": 15315,
	"./people_male1.svg": 77519,
	"./people_male2.svg": 2840,
	"./sign_cancel.svg": 83937,
	"./sign_closed.svg": 7968,
	"./sign_exclamation.svg": 33084,
	"./sign_help.svg": 85542,
	"./sign_info.svg": 76676,
	"./sign_stop.svg": 32628,
	"./sign_warning.svg": 71883,
	"./social_facebook.svg": 69041,
	"./social_google-plus.svg": 85816,
	"./social_instagram.svg": 32636,
	"./social_redit.svg": 16870,
	"./social_twitter.svg": 96651,
	"./soft_bug.svg": 9249,
	"./soft_cursor.svg": 85267,
	"./soft_database.svg": 56667,
	"./soft_database_table.svg": 24354,
	"./soft_feed.svg": 25941,
	"./soft_folder_explore.svg": 65092,
	"./soft_penguin.svg": 19217,
	"./soft_rss.svg": 3297,
	"./sport_basketball.svg": 48271,
	"./sport_football.svg": 76713,
	"./sport_golf.svg": 38190,
	"./sport_raquet.svg": 48359,
	"./sport_shuttlecock.svg": 95169,
	"./sport_soccer.svg": 68589,
	"./sport_tennis.svg": 6238,
	"./tag_blue.svg": 94469,
	"./tag_green.svg": 51466,
	"./tag_orange.svg": 32195,
	"./tag_pink.svg": 24039,
	"./tag_purple.svg": 51542,
	"./tag_red.svg": 72461,
	"./tag_white.svg": 30548,
	"./tag_yellow.svg": 8987,
	"./task_0.svg": 52063,
	"./task_100.svg": 13551,
	"./task_25.svg": 97631,
	"./task_50.svg": 89407,
	"./task_75.svg": 60827,
	"./things_address_book.svg": 69026,
	"./things_bubbles.svg": 57885,
	"./things_pin.svg": 53620,
	"./things_skull.svg": 66020,
	"./things_window-layout.svg": 70648,
	"./things_wrench.svg": 53758,
	"./thumb_thumb_down.svg": 33135,
	"./thumb_thumb_up.svg": 28757,
	"./tick_cross.svg": 8034,
	"./tick_tick.svg": 47576,
	"./time_calendar.svg": 30933,
	"./time_clock.svg": 33131,
	"./time_hourglass.svg": 62315,
	"./weather_clear-night.svg": 23763,
	"./weather_clear.svg": 28488,
	"./weather_few-clouds-night.svg": 65548,
	"./weather_few-clouds.svg": 58257,
	"./weather_overcast.svg": 14740,
	"./weather_severe-alert.svg": 32370,
	"./weather_showers-scattered.svg": 43882,
	"./weather_showers.svg": 24075,
	"./weather_snow.svg": 68058,
	"./weather_storm.svg": 79064
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22545;